import { useState, useEffect, startTransition } from "react"
import _debounce from "lodash/debounce"
import useIsSsr from "@/hooks/useIsSsr"

/**
 *
 * @return {{width, height}}
 */
const useWindowDimensions = () => {
  const isSsr = useIsSsr()
  const [windowDimensions, setWindowDimensions] = useState({
    winWidth: 0,
    winHeight: 0,
  })

  useEffect(() => {
    if (isSsr) {
      return
    }
    const updateDimensions = () => {
      const { innerWidth: winWidth, innerHeight: winHeight } = window
      startTransition(() => {
        setWindowDimensions({ winWidth, winHeight })
      })
    }
    /**
     * Set window dimensions on resize
     */
    const handleResize = _debounce(updateDimensions, 300)
    updateDimensions()
    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [isSsr])

  return windowDimensions
}

export default useWindowDimensions
